import styled from "styled-components";

import { StyledIconButton } from "../button";


export const BodyWrapper = styled.div`
`;

export const ValueInput = styled.div`
    white-space: nowrap;
`;

export const StyledConditionalFilterRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 13px;
    gap: 5px;

    ${StyledIconButton} {
        margin-left: 0;
    }
`;
